<script lang="ts">
  import Icon from "@shared/svelte/Components/Icon.svelte";

  export let heading: string = "ProviPay Frequently Asked Questions";
  export let subtitle: string =
    "Learn more about security, invoice status, credit handling and more at our Helpdesk.";
  export let url: string;

</script>

<div
  class="fizz-bordered fizz-surface fizz-inset-square-24 fizz-radius-xlarge fizz-space-between-32-responsive"
>
  <Icon type="FAQ" width="81" height="81" />
  <div class="fizz-flex-item">
    <h3 class="fizz-heading-3">{heading}</h3>
    <p>{subtitle}</p>
  </div>
  <a href={url} target="_blank" rel="noopener noreferrer" style="text-decoration: none">
    <button class="fizz-button fizz-button-small">Visit help desk</button>
  </a>
</div>
